// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__2go77","compose":"Sidebar_compose__3tvS9","sidebar_footer":"Sidebar_sidebar_footer__3fJBW"};